export enum DashboardTab {
    MINT = "mint",
    NFTS = "nfts",
    INVITES = "invites",
    INVESTS = "FORIXO",
}
